var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14.826,
  height: 9.387,
  viewBox: "0 0 14.826 9.387"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.813 0.813)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.6.6l6,6.5,6-6.5",
  fill: "none",
  stroke: "#e6e6e6",
  strokeLinecap: "round",
  strokeWidth: 2
}))));
export default SvgIconArrow;